// Configurazione centralizzata per i percorsi degli assets
// I file GLB sono ospitati su: https://iscag-ei.it/wp-content/materiale/animazioni-3d/

// Configurazione per 8th Wall con URL esterni
const ASSETS_CONFIG = {
  // URL base per i modelli 3D
  baseUrl: 'https://iscag-ei.it/wp-content/materiale/animazioni-3d',
  
  // URL base per i video
  videoBaseUrl: 'https://iscag-ei.it/wp-content/materiale/ologramma-milone',
  
  // Modelli 3D - URL completi
  models: {
    castelOggi: 'https://iscag-ei.it/wp-content/materiale/animazioni-3d/castel-oggi.glb',
    palladicannone: 'https://iscag-ei.it/wp-content/materiale/animazioni-3d/palladicannone.glb',
    tutaAmianto: 'https://iscag-ei.it/wp-content/materiale/animazioni-3d/Tuta_amianto.glb',
    forno: 'https://iscag-ei.it/wp-content/materiale/animazioni-3d/forno.glb',
    castelIeri: 'https://iscag-ei.it/wp-content/materiale/animazioni-3d/castel-ieri.glb',
    bunker: 'https://iscag-ei.it/wp-content/materiale/animazioni-3d/bunker.glb',
    bleirot: 'https://iscag-ei.it/wp-content/materiale/animazioni-3d/bleirot.glb',
    casteldelmonte: 'https://iscag-ei.it/wp-content/materiale/animazioni-3d/casteldelmonte.glb',
    mitragliatrice: 'https://iscag-ei.it/wp-content/materiale/animazioni-3d/mitragliatrice.glb',
    mongolfiera: 'https://iscag-ei.it/wp-content/materiale/animazioni-3d/mongolfiera.glb',
    nuraghe: 'https://iscag-ei.it/wp-content/materiale/animazioni-3d/nuraghe.glb',
    pontebarche: 'https://iscag-ei.it/wp-content/materiale/animazioni-3d/pontebarche.glb',
    radiomarconi: 'https://iscag-ei.it/wp-content/materiale/animazioni-3d/radiomarconi.glb',
    statuatrapano: 'https://iscag-ei.it/wp-content/materiale/animazioni-3d/statuatrapano.glb',
    stazioneradio: 'https://iscag-ei.it/wp-content/materiale/animazioni-3d/stazioneradio.glb',
    carrosuponte: 'https://iscag-ei.it/wp-content/materiale/animazioni-3d/carrosuponte.glb',
    stemmaricostruire: 'https://iscag-ei.it/wp-content/materiale/animazioni-3d/stemmaricostruire.glb',
    teleferica: 'https://iscag-ei.it/wp-content/materiale/animazioni-3d/teleferica.glb',
    vscalegnobarca: 'https://iscag-ei.it/wp-content/materiale/animazioni-3d/vscalegnobarca.glb',
    idroscivolante: 'https://iscag-ei.it/wp-content/materiale/animazioni-3d/idroscivolante.glb',
    metaldetector: 'https://iscag-ei.it/wp-content/materiale/animazioni-3d/metaldetector.glb',
    aquile: 'https://iscag-ei.it/wp-content/materiale/animazioni-3d/aquile.glb',
    minatorechetrapano: 'https://iscag-ei.it/wp-content/materiale/animazioni-3d/minatorechetrapano.glb',
  },
  
  // Video per esperienze AR con image targets
  videos: {
    filippoNicolai: 'https://iscag-ei.it/wp-content/materiale/video/filippo-nicolai-video.mp4',
    // Aggiungi qui altri video
  },
  
  // Immagini e texture - manteniamo locali per ora
  images: {
    resetButton: '/assets/reset.svg',
    // Aggiungi qui altre immagini
  },
  
  // Funzione helper per costruire percorsi
  getPath: (type, name) => {
    if (type === 'models' && ASSETS_CONFIG.models[name]) {
      return ASSETS_CONFIG.models[name]
    }
    if (type === 'videos' && ASSETS_CONFIG.videos[name]) {
      return ASSETS_CONFIG.videos[name]
    }
    if (type === 'images' && ASSETS_CONFIG.images[name]) {
      return ASSETS_CONFIG.images[name]
    }
    // Fallback: costruisci il percorso
    if (type === 'models') {
      return `${ASSETS_CONFIG.baseUrl}/${name}`
    }
    if (type === 'videos') {
      return `${ASSETS_CONFIG.videoBaseUrl}/${name}`
    }
    return `${ASSETS_CONFIG.basePath}/${name}`
  },
  
  // Funzione per verificare se un asset esiste (per debug)
  validateAsset: (path) => {
    console.log(`Verificando asset: ${path}`)
    // In futuro potremmo aggiungere una verifica reale
    return true
  },
  
  // Funzione per ottenere tutti i modelli disponibili
  getAvailableModels: () => {
    return Object.keys(ASSETS_CONFIG.models)
  },
  
  // Funzione per ottenere tutti i video disponibili
  getAvailableVideos: () => {
    return Object.keys(ASSETS_CONFIG.videos)
  },
  
  // Funzione per aggiungere un nuovo modello
  addModel: (name, filename) => {
    ASSETS_CONFIG.models[name] = `${ASSETS_CONFIG.baseUrl}/${filename}`
    console.log(`Modello aggiunto: ${name} -> ${ASSETS_CONFIG.models[name]}`)
  },
  
  // Funzione per aggiungere un nuovo video
  addVideo: (name, filename) => {
    ASSETS_CONFIG.videos[name] = `${ASSETS_CONFIG.videoBaseUrl}/${filename}`
    console.log(`Video aggiunto: ${name} -> ${ASSETS_CONFIG.videos[name]}`)
  }
}

// Configurazione asset per ologrammi
export const hologramAssets = {
  'blob-shadow': 'https://iscag-ei.it/wp-content/materiale/ologramma-milone/blob-shadow.png', // Fallback a CDN
  'olo-milone-aerofono': 'https://iscag-ei.it/wp-content/materiale/ologramma-milone/olo-milone-aerofono.mp4'
}

// Funzioni helper per l'uso nei template
export const getModelPath = (modelName) => {
  return ASSETS_CONFIG.getPath('models', modelName)
}

export const getVideoPath = (videoName) => {
  if (!videoName) return ASSETS_CONFIG.getPath('videos', videoName)
  // URL assoluto già completo
  if (/^https?:\/\//.test(videoName)) return videoName
  // Mappato esplicitamente
  if (ASSETS_CONFIG.videos[videoName]) return ASSETS_CONFIG.videos[videoName]
  // Fallback: aggiungi estensione .mp4 se manca
  const nameWithExt = videoName.endsWith('.mp4') ? videoName : `${videoName}.mp4`
  return `${ASSETS_CONFIG.videoBaseUrl}/${nameWithExt}`
}

export const getImagePath = (imageName) => {
  return ASSETS_CONFIG.getPath('images', imageName)
}

export const getAssetPath = (path) => {
  return `${ASSETS_CONFIG.baseUrl}/${path}`
}

// Esporta la configurazione completa per uso avanzato
export {ASSETS_CONFIG}

// Funzione per inizializzare e validare tutti gli assets
export const validateAllAssets = () => {
  console.log('Validazione assets...')
  
  // Valida modelli
  Object.entries(ASSETS_CONFIG.models).forEach(([name, path]) => {
    console.log(`Modello ${name}: ${path}`)
    ASSETS_CONFIG.validateAsset(path)
  })
  
  // Valida video
  Object.entries(ASSETS_CONFIG.videos).forEach(([name, path]) => {
    console.log(`Video ${name}: ${path}`)
    ASSETS_CONFIG.validateAsset(path)
  })
  
  console.log('Validazione assets completata')
}

// Funzione per testare il caricamento di un modello
export const testModelLoad = (modelName) => {
  const url = getModelPath(modelName)
  console.log(`Test caricamento modello ${modelName}: ${url}`)
  
  // Test di caricamento asincrono
  fetch(url, { method: 'HEAD' })
    .then(response => {
      if (response.ok) {
        console.log(`✅ Modello ${modelName} disponibile`)
      } else {
        console.error(`❌ Modello ${modelName} non trovato (${response.status})`)
      }
    })
    .catch(error => {
      console.error(`❌ Errore nel caricamento del modello ${modelName}:`, error)
    })
} 